/**
 * Labstep
 *
 * @module components/OrderRequest/Form/ShowEdit/Currency
 * @desc Currency showedit field
 */

import classnames from 'classnames';
import { fieldOrderRequestCurrency } from 'labstep-web/components/OrderRequest/Form/fields';
import { currencies } from 'labstep-web/constants/currencies';
import { FormShowEditSelect as ShowEditSelect } from 'labstep-web/core/Form/ShowEdit/Select';
import styles from 'labstep-web/core/Form/ShowEdit/styles.module.scss';
import type React from 'react';
import type { OrderRequestFormShowEditCurrencyProps } from './types';

export const OrderRequestFormShowEditCurrency: React.FC<
  OrderRequestFormShowEditCurrencyProps
> = ({ orderRequest }) => (
  <ShowEditSelect
    dataCy="components/OrderRequest/Form/ShowEdit/Currency"
    entity={orderRequest}
    field={fieldOrderRequestCurrency}
    disabled={!!orderRequest.purchase_order}
    isClearable={false}
    customShow={({ toggle }) => (
      <div
        data-cy="components/OrderRequest/Form/ShowEdit/Currency"
        data-testid="show-edit-toggle"
        className={classnames('toggle', styles.cursor)}
        onClick={toggle}
      >
        {currencies[orderRequest.currency].symbol}
      </div>
    )}
  >
    {currencies[orderRequest.currency].symbol}
  </ShowEditSelect>
);
